<template>
  <v-list-group disabled
    class="px-0 primary"
    style="width:100%"
    :append-icon="' '">
    <template v-slot:activator>
      <v-list-item-content class="py-0">
        <v-row>
          <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">利用日</v-col>
          <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">顧客名</v-col>
          <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">勘定科目</v-col>
          <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">利用内容</v-col>
          <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">利用額</v-col>
        </v-row>
      </v-list-item-content>
    </template>
  </v-list-group>
</template>

<script>
export default {
  name: 'authorBbookRemoveMitsuisumitomoHeader',
}
</script>